export default "__VITE_ASSET__Cvu7NVR3__"